export const CLIENT_VERSION = 'admin-v1.0.0-26020601';
